import * as React from "react";

export const IconDangerous = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M13.1083 2.5L6.89167 2.5L2.5 6.89167L2.5 13.1083L6.89167 17.5H13.1083L17.5 13.1083V6.89167L13.1083 2.5ZM14.1667 13.1167L13.1167 14.1667L10 11.05L6.88333 14.1667L5.83333 13.1167L8.95 10L5.83333 6.88333L6.88333 5.83333L10 8.95L13.1167 5.83333L14.1667 6.88333L11.05 10L14.1667 13.1167Z"
      fill="currentColor"
    />
  </svg>
);
